import { MutationTree } from "vuex";
import { User, UserMutations, UserState } from "./interface";
import { UserMutationsTypes } from "./types";

export const mutations: MutationTree<UserState> & UserMutations = {
  [UserMutationsTypes.SET_LOGGED_USER](state: UserState, payload: User): void {
    state.logged_user = payload;
  },
  [UserMutationsTypes.SET_LIST_USER](state: UserState, payload: Array<User>): void {
    state.UserById = {};
    state.UserAllId = [];
    payload.forEach((user) => {
      state.UserById[user._id] = user;
      state.UserAllId.push(user._id);
    });
  },
  [UserMutationsTypes.DELETE_USER](state: UserState, payload: User): void {
    delete state.UserById[payload._id];
    state.UserAllId.splice(state.UserAllId.lastIndexOf(payload._id), 1);
  },
  [UserMutationsTypes.DELETE_MULTIPLE_USER](state: UserState, payload: User[]): void {
    payload.map((user) => {
      delete state.UserById[user._id];
      state.UserAllId.splice(state.UserAllId.lastIndexOf(user._id), 1);
    });
  },
  [UserMutationsTypes.UPDATE_USER](state: UserState, payload: User): void {
    state.UserById[payload._id] = payload;
    state.UserAllId.splice(state.UserAllId.lastIndexOf(payload._id), 1);
    state.UserAllId.push(payload._id);
  },
  [UserMutationsTypes.CREATE_USER](state: UserState, payload: User): void {
    state.UserById[payload._id] = payload;
    state.UserAllId.push(payload._id);
  }
};
